import styles from './MainToolbarContextContent.module.css'
import { SettingsSelect } from 'shared/widgets/SettingsSelect'
import { LogoIcon } from 'shared/icons/LogoIcon'
import { Link } from 'react-router-dom'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { CloseButton } from './CloseButton'
import { FilterButton } from './FilterButton'
import { LocationButton } from './LocationButton'
import classNames from 'classnames'
import { SearchButton } from './SearchButton'
import { useState } from 'react'
import { SpyLaunchSettings } from 'shared/types/SpyLaunchSettings'
import { SpyLaunchSettingsButton } from './SpyLaunchSettingsButton/SpyLaunchSettingsButton'

interface MainToolbarContextContentProps {
    location: any
    locationSearchString: string | null
    filter: any
    spyLaunchSettings: any
    locationActive?: boolean
    spyLaunchSettingsActive?: boolean
    filterActive?: boolean
    searchButtonCaption?: string
    filterButtonCaption?: string
    spyLaunchSettingsCaption?: string
    onSearchButtonClick: (event: any) => void
    onLocationButtonClick: (event: any) => void
    onFilterButtonClick: (event: any) => void
    onSpyLaunchSettingsButtonClick: (event: any) => void 
    onFilterCloseButtonClick: (event: any) => void
    onSearchCloseButtonClick: (event: any) => void
    onLaunchSettingsCloseButtonClick: (event: any) => void
}

export const MainToolbarContextContent = (props: MainToolbarContextContentProps): JSX.Element => {
    const {
        location,
        locationSearchString,
        filter,
        spyLaunchSettings,
        locationActive = false,
        spyLaunchSettingsActive = false,
        filterActive = false,
        filterButtonCaption,
        searchButtonCaption,
        spyLaunchSettingsCaption,
        onFilterButtonClick,
        onSearchButtonClick,
        onLocationButtonClick,
        onSpyLaunchSettingsButtonClick,
        onFilterCloseButtonClick,
        onSearchCloseButtonClick,
        onLaunchSettingsCloseButtonClick,
    } = props
  
    const isMediumScreenOrMore = useBreakpointUp('xl')

    const handleFilterButtonClick = (event: any) => {
        onFilterButtonClick?.(event)
    }

    const handleLocationButtonClick = (event: any) => {
        onLocationButtonClick?.(event)
    }

    const handleSearchButtonClick = (event: any) => {
        onSearchButtonClick?.(event)
    }

    const handleSpyLaunchSettingsButtonClick = (event: any) => {
        onSpyLaunchSettingsButtonClick?.(event)
    }

    const handleFiltersCloseButtonClick = (event: any) => {
        onFilterCloseButtonClick?.(event)
    }

    const handleSearchCloseButtonClick = (event: any) => {
        onSearchCloseButtonClick?.(event)
    }

    const handleLaunchSettingsCloseButtonClick = (event: any) => {
        onLaunchSettingsCloseButtonClick?.(event)
    }


    const renderStartContent = (): JSX.Element => {
        if (isMediumScreenOrMore === true) {
            return (
                <div className={styles.MainToolbarContent__StartContainer}>
                    <Link
                        className={styles.MainToolbarContent__Link}
                        to='/'
                    >
                        <LogoIcon
                            className={styles.MainToolbarContent__Logo}
                        />
                    </Link>
                </div>
            )
        }

        return (
            <div className={styles.MainToolbarContent__StartContainer}>
            </div>
        )
    }

    const mainToolbarContentSeparatorBetweenSearchButtonAndSpyLaunchSettingsButtonClasses = classNames(styles.MainToolbarContent__Separator, {
        [styles[`MainToolbarContent__Separator--Hidden`]]: locationActive || spyLaunchSettingsActive
    })   

    const mainToolbarContentSeparatorBetweenLaunchSettingsButtonAndFilterButtonClasses = classNames(styles.MainToolbarContent__Separator, {
        [styles[`MainToolbarContent__Separator--Hidden`]]: spyLaunchSettingsActive || filterActive
    }) 

    const locationSelectClasses = classNames(styles.MainToolbarContent__SearchButton)

    const CenterControlsContainerClasses = classNames(styles.MainToolbarContent__CenterControlsContainer, {
        [styles[`MainToolbarContent__CenterControlsContainer--Active`]]: locationActive || spyLaunchSettingsActive || filterActive
    })

    const searchButtonVariant = (locationActive || spyLaunchSettingsActive || filterActive) ? 'normal': 'compact'

    const renderCenterContent = (): JSX.Element => {
        if (isMediumScreenOrMore === true) {
            return (
                <div className={styles.MainToolbarContent__CenterContainer}>
                    <div className={CenterControlsContainerClasses}>
                        <div className={styles.MainToolbarContent__LocationSelectContainer}>
                            <LocationButton
                                className={locationSelectClasses}
                                onClick={handleLocationButtonClick}
                                caption={`Select Location`}
                                location={location}
                                filters={filter}
                                spyLaunchSettings={spyLaunchSettings}
                                active={locationActive}
                            />
                        </div>
                        <div className={styles.MainToolbarContent__SeparatorContainer}>
                            <div className={mainToolbarContentSeparatorBetweenSearchButtonAndSpyLaunchSettingsButtonClasses}></div>
                        </div>
                        <div>
                            <SpyLaunchSettingsButton
                                onClick={handleSpyLaunchSettingsButtonClick}
                                value={spyLaunchSettings}
                                active={spyLaunchSettingsActive}
                            />
                        </div>
                        <div className={styles.MainToolbarContent__SeparatorContainer}>
                            <div className={mainToolbarContentSeparatorBetweenLaunchSettingsButtonAndFilterButtonClasses}></div>
                        </div>
                        <div className={styles.MainToolbarContent__FilterButtonAndSearchButtonContainer}>
                            <FilterButton
                                filters={filter}
                                onClick={handleFilterButtonClick}
                                active={filterActive}
                            />
                            <div className={styles.MainToolbarContent__SearchButtonContainer}>
                                <SearchButton 
                                    onClick={handleSearchButtonClick}
                                    variant={searchButtonVariant}
                                />
                            </div>              
                        </div>
                    </div>
                </div>
            )
        }
        
        return (
               <div className={styles.MainToolbarContent__CenterContainer}>
                   <div className={styles.MainToolbarContent__LocationSelectContainer}>
                       <LocationButton
                           className={styles.MainToolbarContent__LocationSelect}
                           onClick={handleLocationButtonClick}
                           caption={searchButtonCaption ? searchButtonCaption : ``}
                           active={locationActive}
                           location={location}
                           filters={filter}
                           spyLaunchSettings={spyLaunchSettings}
                       />
                   </div>
               </div>
        )
    }

    const renderEndContent = (): JSX.Element => {
            if (isMediumScreenOrMore === true) {
                return (
                    <div className={styles.MainToolbarContent__EndContainer}>
                        <SettingsSelect />
                    </div>
                )
            }

            return (
                <div className={styles.MainToolbarContent__EndContainer}>
                </div>
            )
    }

    return (
        <div className={styles.MainToolbarContent}>
            {renderStartContent()}
            {renderCenterContent()}
            {renderEndContent()}
        </div>
    )
}